import React from 'react';
import { Card, CardContent } from './ui/card';
import { Badge } from './ui/badge';
import { Button } from './ui/button';
import { ExternalLink, CheckCircle } from 'lucide-react';
// Props: certifications

const Certifications = ({ certifications }) => {
  if (!certifications) return null;
  return (
    <section id="certifications" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Certifications</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Professional certifications and continuous learning
          </p>
          <div className="w-20 h-1 bg-blue-900 mx-auto mt-6"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {certifications.map((cert) => (
            <Card key={cert.id} className="border-2 border-gray-100 hover:border-blue-200 transition-all hover:shadow-lg">
              <CardContent className="p-6">
                <div className="flex gap-4">
                  {/* Logo Placeholder */}
                  <div className="flex-shrink-0">
                    <div className="w-16 h-16 bg-gradient-to-br from-blue-100 to-blue-200 rounded-lg flex items-center justify-center">
                      <CheckCircle className="w-8 h-8 text-blue-900" />
                    </div>
                  </div>
                  
                  <div className="flex-1">
                    <h3 className="font-bold text-lg text-gray-900 mb-1">{cert.name}</h3>
                    <p className="text-sm text-blue-900 font-medium mb-2">{cert.issuer}</p>
                    <p className="text-sm text-gray-500 mb-3">{cert.date}</p>
                    
                    <p className="text-gray-700 text-sm mb-4">{cert.description}</p>
                    
                    {cert.courses && cert.courses.length > 0 && (
                      <div className="mb-4">
                        <p className="text-sm font-semibold text-gray-900 mb-2">Course Modules:</p>
                        <div className="space-y-1">
                          {cert.courses.map((course, index) => (
                            <div key={index} className="flex items-start gap-2">
                              <span className="text-blue-900 text-xs mt-1">•</span>
                              <span className="text-xs text-gray-600">{course}</span>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                    
                    <Button
                      onClick={() => window.open(cert.credentialUrl, '_blank')}
                      variant="outline"
                      size="sm"
                      className="w-full"
                    >
                      <ExternalLink className="w-4 h-4 mr-2" />
                      Verify Credential
                    </Button>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Certifications;
